import axios from 'axios'
import { router } from '../router'

import { useAdminStore } from '../stores/admin'
import { useProducerStore } from '../stores/producer'
import { useSnackBar } from '@/stores/snackbar'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.request.use(
  (config) => {
    if (useProducerStore().producer !== null) {
      config.headers.set('Producer-Id', useProducerStore().producer!.id)
    }

    if (useAdminStore().token !== null) {
      config.headers.set('Authorization', `Bearer ${useAdminStore().token}`)
    }

    return config
  },
)

http.interceptors.response.use(
  response => response,
  (error) => {
    useSnackBar().fromAxiosResponse(error.response)

    if (error.response.status === 401) {
      useAdminStore().logout()
      router.push('/login')
    }

    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- `error` is always the AxiosError instance axios passes in; wrapping it would strip `.response` that callers rely on
    return Promise.reject(error)
  },
)

export { http }
